import React from "react";
import { Card } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import Container from "react-bootstrap/Container";

const Additional = () => {
  return (
    <AdditionalStyled className="Additional">
      <Container>
        <h1>Additional Resources</h1>
        <p>Additional Tax Resources for Tax Practitioners</p>
        <Row>
          <Col>
            <Card style={{ width: "24rem", height: "33rem" }}>
              <Card.Img
                id="federal"
                variant="top"
                src="https://westerncpe.s3.amazonaws.com/tax-app/federal-gradient.jpg"
              />
              <Card.ImgOverlay>
                <Card.Title>Federal Tax Rate Sources</Card.Title>
              </Card.ImgOverlay>
              <Card.Body>
                <Card.Text>
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-25-32.pdf"
                    target="blank"
                  >
                    <strong>2026 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-24-40.pdf"
                    target="blank"
                  >
                    <strong>2025 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-23-34.pdf"
                    target="blank"
                  >
                    <strong>2024 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-22-38.pdf"
                    target="blank"
                  >
                    <strong>2023 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-21-45.pdf"
                    target="blank"
                  >
                    <strong>2022 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-20-45.pdf"
                    target="blank"
                  >
                    <strong>2021 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-19-44.pdf"
                    target="blank"
                  >
                    <strong>2020 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-18-57.pdf"
                    target="blank"
                  >
                    <strong>2019 Federal Tax Rates</strong>
                  </a>
                  <br />
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-17-58.pdf"
                    target="blank"
                  >
                    <strong>2018 Federal Tax Rates</strong>
                  </a>
                  <br />
                  {/*
                  <a
                    href="https://www.irs.gov/pub/irs-drop/rp-16-55.pdf"
                    target="blank"
                  >
                    <strong>2017 Federal Tax Rates</strong>
                  </a>
                  <br />
                */}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card style={{ width: "24rem", height: "30rem" }}>
              <Card.Img
                id="cali"
                variant="top"
                src="https://westerncpe.s3.amazonaws.com/tax-app/california-gradient.jpg"
              />
              <Card.ImgOverlay>
                <Card.Title>California Tax Rate Sources</Card.Title>
              </Card.ImgOverlay>
              <Card.Body>
                <Card.Text>
                  <a
                    href="https://www.ftb.ca.gov/file/personal/tax-calculator-tables-rates.asp"
                    target="blank"
                  >
                    <strong>Historical California Tax Rates</strong>
                  </a>
                  <br />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card style={{ width: "24rem", height: "30rem" }}>
              <Card.Img
                id="add"
                variant="top"
                src="https://westerncpe.s3.amazonaws.com/tax-app/additional+resources+(1).jpg"
              />
              <Card.ImgOverlay>
                <Card.Title>Previous Desktop References</Card.Title>
              </Card.ImgOverlay>
              <Card.Body>
                <Card.Text>
                  <a
                    href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/2026+Court+Cases/2025+Federal-California-Desk-Reference.pdf"
                    target="blank"
                  >
                    <strong>
                      <u>2025 Federal Desktop Reference Download</u>
                    </strong>
                  </a>
                  <br />
                  <a
                    href="https://www.westerncpe.com/wp-content/uploads/2024/11/2024-FEDERAL-TAX-RATE-SCHEDULES.pdf"
                    target="blank"
                  >
                    <strong>
                      <u>2024 Federal Desktop Reference Download</u>
                    </strong>
                  </a>
                  <br />
                  <a
                    href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/2023+FEDERAL+TAX+RATE+SCHEDULE+Final.pdf"
                    target="blank"
                  >
                    <strong>
                      <u>2023 Federal Desktop Reference Download</u>
                    </strong>
                  </a>
                  <br />
                  <a
                    href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/Desktop+Reference+for+CFTU+2022.pdf"
                    target="blank"
                  >
                    <strong>
                      <u>2022 Federal Desktop Reference Download</u>
                    </strong>
                  </a>
                  <br />
                  <a
                    href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/Desktop+Reference+for+CFTU+2021+(UPDATED)+(1).pdf"
                    target="blank"
                  >
                    <strong>
                      <u>2021 Federal Desktop Reference Download</u>
                    </strong>
                  </a>
                  <br />
                  <a
                    href="https://westerncpe-ftu-media.s3.us-west-1.amazonaws.com/2019-Desktop-Reference-1.pdf"
                    target="blank"
                  >
                    <strong>
                      <u>2019 Federal Desktop Reference Download</u>
                    </strong>
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </AdditionalStyled>
  );
};

export default Additional;

const AdditionalStyled = styled.div`
  min-height: 80vh;

  h1 {
    text-align: center;
    padding-top: 50px;
    padding-bottom: 25px;
  }
  p {
    text-align: center;
    padding-bottom: 50px;
  }
  #federal {
    border-bottom: 5px solid #00488e;
  }
  #cali {
    border-bottom: 5px solid #ea5151;
  }
  #add {
    border-bottom: 5px solid #66d49d;
  }
  .card {
    padding-bottom: 0.5em;
    margin: 5px auto;
  }
  .card-img-overlay {
    height: 0px;
    overflow: visible;
    pointer-events: none;
    background: none !important;
  }
  .card-title {
    font-size: 20px;
    text-align: center;
    color: white;
    font-weight: bold;
    padding-bottom: 0.5em;
    margin-top: 25%;
  }
  .card-body {
    padding: 1.375rem 2rem;
  }
  .card-body p {
    line-height: 1.7;
  }

  .col {
    margin-bottom: 25px;
  }
  @media (max-width: 767px) {
    .card {
      margin: 5px auto;
    }
    .col {
      margin-bottom: 15px;
    }
  }
  @media (min-width: 768px) {
    .card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: auto;
    }
  }
`;
